import React from 'react'
import PropTypes from 'prop-types'

export const Header = ({ className = '', children = null }) => (
  <header className={className}>{children}</header>
)

Header.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
  ]),
}
